import { client } from '@atlassian/rovo-content-bridge-api';
var CLIENT_ID_PREFIX = 'rovo-broadcast-confirmed-actions';

/**
 * Generates a client ID for Rovo broadcast confirmed actions by appending the provided ID
 * to a predefined client ID prefix.
 *
 * @param id - The unique identifier to append to the client ID prefix.
 * @returns The constructed client ID string for the Rovo broadcast confirmed actions client.
 */
export var getRovoBroadcastConfirmedActionsClientId = function getRovoBroadcastConfirmedActionsClientId(id) {
  return client("".concat(CLIENT_ID_PREFIX, "-").concat(id));
};

/**
 * Determines if the provided client ID belongs to a Rovo Broadcast Confirmed Actions client. Useful to filter broadcast recipients.
 *
 * @param clientId - The client ID to check.
 * @returns `true` if the client ID starts with the expected prefix for Rovo Broadcast Confirmed Actions; otherwise, `false`.
 */
export function isRovoBroadcastConfirmedActions(clientId) {
  return clientId.startsWith(CLIENT_ID_PREFIX);
}